import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { DropdownMenuItem } from './DropdownMenuItem'

export const DropdownMenu = () => {
  const { subHeaderMenu } = useGlobalNavigation()

  return (
    <div className="flex flex-row items-center gap-6 ml-auto">
      {subHeaderMenu.map((el, index: number) => (
        <DropdownMenuItem key={`dropmenu-item-${index}`} dropdownMenu={el} />
      ))}
    </div>
  )
}
